import type { SVGProps } from "react";

export function IconPurpleArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M12.5601 57V7L57.0045 32L12.5601 57Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M12.5601 32H26.5601"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
